// extracted by mini-css-extract-plugin
export default {"listContainer":"PrivacyPolicy_listContainer__dDKyi","lastUpdated":"PrivacyPolicy_lastUpdated__HURRV marketplaceBodyFontStyles"};